export const createIgnoreZonesLinksArray = (pushedArray: any) => {
  const linksArray = [{ name: "Sites" }];
  pushedArray.forEach((name: string) => {
    linksArray.push({ name: name });
  });
  return linksArray;
};
